<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="ORGJED.NAZIV.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              [Label]="'ORGJED.SINGULAR'"
              formControlName="Naziv"                                               
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
              [Label]="'ORGJED.NAZIV.SINGULAR'">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>                  
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-md-12">
      <app-sist-radnih-mesta-stavka-update-container
        #baseInlineContainer
        [DetailModelData]="modelData.MainList.DetailList[0]"
        [ParentPropertyName]="'OrgJedID'"
        [ParentPropertyValue]="Item.ID"
        [Parameters]="TransferParameters"     
      >
      </app-sist-radnih-mesta-stavka-update-container>
    </div>
  </form>
</div>